import { render, staticRenderFns } from "./FloatingContactBar.vue?vue&type=template&id=067334fb&scoped=true&"
import script from "./FloatingContactBar.vue?vue&type=script&lang=js&"
export * from "./FloatingContactBar.vue?vue&type=script&lang=js&"
import style0 from "./FloatingContactBar.vue?vue&type=style&index=0&id=067334fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067334fb",
  null
  
)

export default component.exports